import parse from "html-react-parser";

export const currencies = {
  nis: "₪",
  eur: "€",
  usd: "$",
  ILS: "₪",
};

export const filesPerPage = 50;

export const findFolderWithConditions = (folderId, foldersData) => {
  const folder = foldersData[folderId];

  if (
    !folder.haveFiles &&
    folder.containedFoldersId &&
    folder.containedFoldersId.length < 2
  ) {
    const nestedFolderId = folder.containedFoldersId[0];

    if (nestedFolderId) {
      const nestedFolder = foldersData[nestedFolderId];

      if (
        !nestedFolder.haveFiles &&
        nestedFolder.containedFoldersId &&
        nestedFolder.containedFoldersId.length < 2
      ) {
        return findFolderWithConditions(nestedFolderId, foldersData);
      }

      return nestedFolderId;
    }

    return folderId;
  }

  return null;
};

export const calcWidth = (width) => {
  const curWidth = width || window.innerWidth; //prevents error if width is 0
  //384 px - is size for 1 column, 5 columns = 1920px
  const columnWidth = Math.round(100 / Math.round(curWidth / 250));
  return `${columnWidth < 100 ? columnWidth : 100}%`;
};

export const arrayEquals = (a, b) => {
  return (
    Array.isArray(a) &&
    Array.isArray(b) &&
    a.length === b.length &&
    a.every((val, index) => val === b[index])
  );
};

export function get_browser() {
  var ua = navigator.userAgent,
    tem,
    M =
      ua.match(
        /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
      ) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return { name: "IE", version: tem[1] || "" };
  }
  if (M[1] === "Chrome") {
    tem = ua.match(/\bOPR|Edge\/(\d+)/);
    if (tem != null) {
      return { name: "Opera", version: ua.split("OPR/")[1].split(".")[0] };
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) {
    M.splice(1, 1, tem[1]);
  }
  return {
    name: M[0].toLowerCase(),
    version: M[1],
  };
}

export const detectOldBrowser = () => {
  const browserInfo = get_browser();
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  const isMobile = /iPhone|iPad|iPod|Android/i.test(ua);
  if (isMobile) return false;
  if (
    (browserInfo.name.toLowerCase() === "chrome" && browserInfo.version < 50) ||
    (browserInfo.name.toLowerCase() === "safari" && browserInfo.version < 6) ||
    (browserInfo.name.toLowerCase() === "opera" && browserInfo.version < 37) ||
    (browserInfo.name.toLowerCase() === "ie" && browserInfo.version < 8) ||
    !browserInfo.version
  ) {
    return (
      JSON.stringify(browserInfo) + "________________" + JSON.stringify(ua)
    );
  }
  return false;
};

const getSortedFiles = (filesData, sortingData) => {
  return Object.keys(filesData).sort((a, b) => {
    const valueA = filesData[a][sortingData.by] || "";
    const valueB = filesData[b][sortingData.by] || "";

    const compareValueA =
      typeof valueA === "string" ? valueA.toLowerCase() : valueA;
    const compareValueB =
      typeof valueB === "string" ? valueB.toLowerCase() : valueB;

    if (sortingData.by === "Name") {
      // Natural sorting logic for names containing numbers
      const extractChunks = (str) => {
        return str
          .match(/\d+|\D+/g)
          .map((chunk) =>
            isNaN(chunk) ? chunk.toLowerCase() : parseInt(chunk, 10)
          );
      };

      const chunksA = extractChunks(compareValueA);
      const chunksB = extractChunks(compareValueB);

      for (let i = 0; i < Math.max(chunksA.length, chunksB.length); i++) {
        const chunkA = chunksA[i] || "";
        const chunkB = chunksB[i] || "";

        if (chunkA !== chunkB) {
          if (typeof chunkA === "number" && typeof chunkB === "number") {
            return sortingData.asc ? chunkA - chunkB : chunkB - chunkA;
          }
          if (typeof chunkA === "number" && typeof chunkB === "string") {
            return sortingData.asc ? 1 : -1;
          }
          if (typeof chunkA === "string" && typeof chunkB === "number") {
            return sortingData.asc ? -1 : 1;
          }
          return sortingData.asc
            ? chunkA.localeCompare(chunkB)
            : chunkB.localeCompare(chunkA);
        }
      }
      // Names are equal
      return 0;
    }

    // Default sorting for other fields
    if (compareValueA < compareValueB) {
      return sortingData.asc ? -1 : 1;
    }
    if (compareValueA > compareValueB) {
      return sortingData.asc ? 1 : -1;
    }
    // Values are equal
    return 0;
  });
};

export const sortingFiles = (
  filesData,
  foldersData,
  foldersList,
  sortingData,
  isFolderStructured,
  isCollectionSelected
) => {
  if (!sortingData) return [];
  if (isCollectionSelected) {
    return getSortedFiles(filesData, sortingData);
  }
  if (!isFolderStructured) {
    const sortedNamesFilesList = getSortedFiles(filesData, sortingData);
    if (foldersList.length > 0) {
      const ascFoldersList = foldersList.filter(
        (folderId) => parseInt(folderId) !== 1
      );

      const descFoldersList = ascFoldersList.slice().reverse();

      const sortedFoldersList =
        sortingData.by !== "Name" || sortingData.asc
          ? ascFoldersList
          : descFoldersList;

      const filesArray = [];

      sortedNamesFilesList.forEach((fileId) => {
        filesData[fileId].folderId === 1 && filesArray.push(fileId);
      });

      // filesArray.length > 0 && filesArray.push({ folder: "root" });
      sortedFoldersList.forEach((folderId) => {
        if (folderId !== 0 && foldersData[folderId].haveFiles) {
          filesArray.push({ folder: folderId });
          sortedNamesFilesList.forEach((fileId) => {
            filesData[fileId].folderId == folderId && filesArray.push(fileId);
          });
        }
      });

      // now remove all folders if they are last in the list
      while (filesArray[filesArray.length - 1]?.folder) {
        filesArray.pop();
      }
      return filesArray;
    }
    return sortedNamesFilesList;
  }

  if (sortingData.by === "Extention") {
    // creating array of files sorted by name
    const sortedNamesFilesList = Object.keys(filesData).sort((a, b) => {
      const valueA = filesData[a].Name.toLowerCase();
      const valueB = filesData[b].Name.toLowerCase();
      if (valueA < valueB) {
        return sortingData.asc ? -1 : 1;
      }
      if (valueA > valueB) {
        return sortingData.asc ? 1 : -1;
      }
      // names must be equal
      return 0;
    });
    // creating object of exisiting extentions in files and relevant fileId in each extention
    const extentionObject = {};
    // creating array of files sorted by extention
    const sortedFilesList = [];
    sortedNamesFilesList.forEach((fileId) => {
      const extention = filesData[fileId].Extention;
      if (!extention || extention === "") {
        sortedFilesList.push(fileId);
        return;
      }
      if (extentionObject[extention]) {
        extentionObject[extention].push(fileId);
      } else {
        extentionObject[extention] = [fileId];
      }
    });
    // creating extentions list sorted by name
    const extentionSortedList = Object.keys(extentionObject).sort((a, b) => {
      const valueA = a.toLowerCase();
      const valueB = b.toLowerCase();
      if (valueA < valueB) {
        return sortingData.asc ? -1 : 1;
      }
      if (valueA > valueB) {
        return sortingData.asc ? 1 : -1;
      }
      // names must be equal
      return 0;
    });
    // looping through extentions list and adding files to sortedFilesList
    extentionSortedList.forEach((extention) => {
      sortedFilesList.push({ folder: extention });
      extentionObject[extention].forEach((fileId) => {
        sortedFilesList.push(fileId);
      });
    });
    return sortedFilesList;
  } else {
    return getSortedFiles(filesData, sortingData);
  }
};

export const replaceKeysForHTML = (textWithKey, replaceObject) => {
  const parsedArray = parse(textWithKey);
  if (Array.isArray(parsedArray)) {
    const renderText = parsedArray.map((item) => {
      if (typeof item === "string") {
        const constArray = item.split("#");
        return constArray.map((textElem, i) => {
          return !(i % 2) ? textElem : replaceObject[textElem];
        });
      } else {
        return item;
      }
    });
    return renderText;
  } else {
    const constArray = parsedArray.split("#");
    return constArray.map((textElem, i) => {
      return !(i % 2) ? textElem : replaceObject[textElem];
    });
  }
};

export const validationFunction = (reg, string) => {
  if (typeof reg === "boolean") {
    return string;
  }
  if (typeof reg === "function") {
    return reg(string);
  }
  return reg.test(string);
};

export const getDateFormatForInput = (dateString) => {
  const curr = new Date(dateString);
  var dateTOSHow = curr.toISOString().substr(0, 10);
  return dateTOSHow;
};
